import { DigitalVisitReasonEnum } from '@src/lib/__generated/api';

/**
 * @method ageEligibleForProcedure()
 *
 * MottoAligners and other visit types have age restrictions for online
 * booking, this method contains all logic for those restrictions.
 */
export const ageEligibleForProcedure = (patientAge: number, visitReason: DigitalVisitReasonEnum) => {
	const { ClearAligners, Dentures, Implants } = DigitalVisitReasonEnum;

	if (patientAge < 16 && visitReason === ClearAligners) return false;
	if (patientAge < 18 && [Dentures, Implants].includes(visitReason)) return false;

	return true;
};

/**
 * @method guarantorInformationNeeded()
 *
 * Regardless of all of the age rules related to different types
 * of appointments, consistent behavior is that if a user is able
 * to create the appoitment but patient is under 18, guarantor
 * form is required.
 *
 */
export const guarantorInformationNeeded = (patientAge: number) => patientAge < 18;
